export const ACCOUNT_TAB = 'account' as const;
export const ADS_TAB = 'ads' as const;

export type TransactionTabType = typeof ACCOUNT_TAB | typeof ADS_TAB;

export const OPERATION_DIRECTION = {
  INCOME: 'income',
  EXPENSE: 'expense',
} as const;

export const DEFAULT_PAGE_SIZE = 24;

export const OPERATIONS_TABLE_COLUMNS = '2fr 1.5fr 1fr 1.25fr 1fr 14px';
